import GET_USERNAME from '@/graphql/User/getName.gql';
import GET_USER from '@/graphql/User/getUser.gql';
import UPDATE_PASSWORD from '@/graphql/User/updatePassword.gql';
import UPDATE_USER from '@/graphql/User/updateUser.gql';
import UPDATE_USER_ADDRESS from '@/graphql/User/updateAddress.gql';
import {authClient, axios} from '../main';

export default class UserResource {
    async get () {
        return await authClient.query({
            query: GET_USER,
            update: data => data.me
        })
    }
    getInfo () {
        return authClient.query({
            query: GET_USER,
            update: data => data.me
        })
    }

    async getIntegrations (websiteId) {
        return await authClient.query({
            query: GET_USER,
            variables: {
                websiteId: websiteId
            },
            update: data => data.me
        })
    }


    async getName () {
        return await authClient.query({
            query: GET_USERNAME,
            update: data => data.me.full_name
        })
    }

    async update (User) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_USER,
            variables: {
                firstName: User.first_name,
                lastName: User.last_name,
                email: User.email,
                phone: User.phone,
                address1: User.address_1,
                address2: User.address_2,
                state: User.state,
                city: User.city,
                postcode: User.postcode,
                company: User.company,
                vat: User.vat,
                countryCode: User.country.code
            }
        })
    }

    async updateAddress (countryCode, state, company, postcode, streetName, city, vat) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_USER_ADDRESS,
            variables: {
                countryCode: countryCode,
                state: state,
                company: company,
                postcode: postcode,
                streetName: streetName,
                city: city,
                vat: vat
            }
        })
    }

    async updatePassword (oldPassword, newPassword, repeatPassword) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_PASSWORD,
            variables: {
                oldPassword: oldPassword,
                password: newPassword,
                passwordConfirmation: repeatPassword
            }
        })
    }
}
